import {
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Scatter,
  ScatterChart,
  Tooltip,
  XAxis,
  YAxis
} from 'recharts'

import { cap } from '../../State'
import { translations } from '../../translations'
import {
  CHART_ANIMATION_FAST,
  CHART_AXIS_LINE,
  CHART_AXIS_TICK,
  CHART_GRID_PROPS,
  CHART_LEGEND_STYLE,
  CHART_MARGIN,
  CHART_TOOLTIP_STYLE
} from './chartTheme'

const language = cap.language.state || 'IT'
const t = translations[language]

export const ScatterChartComponent = ({
  data,
  xaxis,
  yaxis,
  cartesian,
  legend,
  dataKeys,
  yAxisProps,
  xAxisProps,
  tooltipProps,
  scatterProps
}) => {
  return (
    <ResponsiveContainer width="100%" height="100%">
      <ScatterChart margin={CHART_MARGIN}>
        {cartesian ? <CartesianGrid {...CHART_GRID_PROPS} /> : null}
        {xaxis ? (
          <XAxis
            dataKey={typeof xaxis === 'string' ? xaxis : 'name'}
            tick={CHART_AXIS_TICK}
            axisLine={CHART_AXIS_LINE}
            tickLine={false}
            {...xAxisProps}
          />
        ) : null}
        {yaxis ? (
          <YAxis tick={CHART_AXIS_TICK} axisLine={false} tickLine={false} {...yAxisProps} />
        ) : null}
        <Tooltip contentStyle={CHART_TOOLTIP_STYLE} {...tooltipProps} />
        {legend ? (
          <Legend wrapperStyle={CHART_LEGEND_STYLE} iconType="circle" iconSize={8} />
        ) : null}
        <Scatter
          name={t.executionTime}
          data={data}
          fill="var(--primary)"
          fillOpacity={0.7}
          animationDuration={CHART_ANIMATION_FAST.duration}
          animationEasing={CHART_ANIMATION_FAST.easing}
          {...scatterProps}
        />
      </ScatterChart>
    </ResponsiveContainer>
  )
}
